import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { toast } from 'sonner';
import api from '../../utils/api';
import { useTenant } from '../../context/TenantContext';

const CatalogTaxModels = () => {
  const { activeTenant } = useTenant();
  const [models, setModels] = useState([]);
  const [formData, setFormData] = useState({ code: '', name: '', frequency: '', description: '' });

  const loadModels = () => {
    if (!activeTenant) return;
    api.get(`/catalog/tax-models?tenant_id=${activeTenant}`)
      .then((res) => setModels(res.data || []))
      .catch(() => toast.error('Error al cargar modelos'));
  };

  useEffect(() => {
    loadModels();
  }, [activeTenant]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.code || !formData.name) {
      toast.error('Codigo y nombre son requeridos');
      return;
    }
    try {
      await api.post('/catalog/tax-models', { ...formData, tenant_id: activeTenant });
      toast.success('Modelo registrado');
      setFormData({ code: '', name: '', frequency: '', description: '' });
      loadModels();
    } catch (error) {
      toast.error('Error al guardar modelo');
    }
  };

  const handleDelete = async (modelId) => {
    try {
      await api.delete(`/catalog/tax-models/${modelId}`);
      toast.success('Modelo eliminado');
      loadModels();
    } catch (error) {
      toast.error('Error al eliminar modelo');
    }
  };

  return (
    <div className="max-w-5xl mx-auto space-y-6" data-testid="catalog-tax-models">
      <div>
        <h1 className="text-3xl font-heading font-bold">Catalogo de modelos de impuestos</h1>
        <p className="text-muted-foreground">Configura los modelos fiscales para el tenant.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Nuevo modelo</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label>Codigo *</Label>
              <Input value={formData.code} onChange={(e) => setFormData({ ...formData, code: e.target.value })} />
            </div>
            <div>
              <Label>Nombre *</Label>
              <Input value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
            </div>
            <div>
              <Label>Frecuencia</Label>
              <Input value={formData.frequency} onChange={(e) => setFormData({ ...formData, frequency: e.target.value })} />
            </div>
            <div className="md:col-span-2">
              <Label>Descripcion</Label>
              <Textarea value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} />
            </div>
            <div className="md:col-span-2">
              <Button type="submit">Guardar modelo</Button>
            </div>
          </form>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Modelos registrados</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {models.length === 0 ? (
            <div className="px-6 py-6 text-sm text-muted-foreground">No hay modelos registrados.</div>
          ) : (
            models.map((model) => (
              <div key={model.id} className="flex items-center justify-between px-6 py-4 border-b last:border-b-0">
                <div>
                  <div className="font-medium">{model.code} - {model.name}</div>
                  <div className="text-xs text-muted-foreground">{model.frequency || 'Sin frecuencia'}</div>
                </div>
                <Button variant="ghost" size="sm" onClick={() => handleDelete(model.id)}>
                  Eliminar
                </Button>
              </div>
            ))
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default CatalogTaxModels;
